<template>
  <v-dialog :model-value="modelValue" max-width="640px" :persistent="saving" @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title class="bg-primary text-white d-flex align-center">
        <v-icon class="mr-2">{{ conflict ? 'mdi-alert-octagon-outline' : 'mdi-delete-outline' }}</v-icon>
        <span>{{ $t('accessLevelLadderDeleteTitle', { code }) }}</span>
      </v-card-title>
      <v-card-text class="pt-4 dialog-scroll">
        <template v-if="conflict">
          <v-alert type="error" variant="tonal" density="comfortable" class="mb-4">
            <div class="font-weight-bold">{{ $t('accessLevelLadderDeleteBlocked', { code }) }}</div>
            <div v-if="conflict.message" class="text-caption mt-1">{{ conflict.message }}</div>
          </v-alert>
          <div v-if="conflict.intents.length" class="mb-4">
            <div class="text-subtitle-2 mb-1">{{ $t('accessLevelLadderDeleteBlockedIntents', { count: conflict.intents.length }) }}</div>
            <access-level-usage-list :intents="conflict.intents" />
          </div>
          <div class="text-caption text-grey-darken-1">{{ $t('accessLevelLadderDeleteBlockedHint') }}</div>
        </template>
        <template v-else>
          <v-alert v-if="error" type="error" variant="tonal" density="comfortable" class="mb-4">{{ error }}</v-alert>
          <div class="text-body-1">{{ $t('accessLevelLadderDeleteConfirm', { code }) }}</div>
        </template>
      </v-card-text>
      <v-card-actions class="pb-4 px-6">
        <v-spacer />
        <v-btn variant="text" class="text-none" :disabled="saving" @click="$emit('update:modelValue', false)">
          {{ conflict ? $t('accessLevelLadderClose') : $t('accessLevelLadderCancel') }}
          <v-tooltip activator="parent" location="top">{{ conflict ? $t('accessLevelLadderClose') : $t('accessLevelLadderCancel') }}</v-tooltip>
        </v-btn>
        <v-btn v-if="!conflict && canDelete" color="error" variant="flat" class="text-none" :loading="saving" @click="$emit('confirm')">
          {{ $t('accessLevelLadderDelete') }}
          <v-tooltip activator="parent" location="top">{{ $t('accessLevelLadderDelete') }}</v-tooltip>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AccessLevelUsageList from './AccessLevelUsageList.vue';

/**
 * dialog ยืนยันลบระดับของหน้า `/AccessLevelConfig` (#914) — กด "ลบ" ⇒ emit `confirm` ให้หน้าแม่ยิง `DELETE /{id}`
 * · server ตอบ 409 ⇒ หน้าแม่ส่ง `conflict` มา ⇒ dialog เปลี่ยนเป็น "ลบไม่ได้" แสดง flow › router › intent
 */
export default {
  name: 'AccessLevelDeleteDialog',
  components: { AccessLevelUsageList },
  props: {
    modelValue: { type: Boolean, default: false },
    code: { type: String, default: '' },
    /** `{ message, intents: AccessLevelIntentUsageDto[] }` · null = ยังไม่ติด 409 */
    conflict: { type: Object, default: null },
    error: { type: String, default: '' },
    saving: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: false },
  },
  emits: ['update:modelValue', 'confirm'],
};
</script>

<style scoped>
.dialog-scroll {
  max-height: 65vh;
  overflow-y: auto;
}
</style>
